import React from 'react';
import './layer-togglers.scss';
import { Checkbox } from '../forms';
import LayerToggleControl, { LayerToggleCheckbox, LayerToggleRadio } from './layer-toggler';
import { UnitsVisibility } from './types/units-visibility';

const LayerTogglers = props => {

    return (
        <div className="layer-togglers">
            <LayerToggleControl title={`Visar`}>
                <LayerToggleRadio
                    label={`Dölj ${props.type === 'foodservice' ? 'enheter' : 'butiker'}`}
                    checked={props.unitsVisible === UnitsVisibility.NONE}
                    onChange={(e) => props.toggleUnits(UnitsVisibility.NONE)}
                />
                <LayerToggleRadio
                    label={`Alla ${props.type === 'foodservice' ? 'enheter' : 'butiker'}`}
                    checked={props.unitsVisible === UnitsVisibility.ALL}
                    onChange={(e) => props.toggleUnits(UnitsVisibility.ALL)}
                />
                <LayerToggleRadio
                    label={`${props.type === 'foodservice' ? 'Enheter' : 'Butiker'} endast i säljdistrikt`}
                    checked={props.unitsVisible === UnitsVisibility.AREA}
                    onChange={(e) => props.toggleUnits(UnitsVisibility.AREA)}
                />
            </LayerToggleControl>
     
            <label className="layer-togglers__control">
                <Checkbox onChange={(e) => props.toggleDemographics(e)} />
                <span>Visa demografi</span>
            </label>
            
            <LayerToggleControl title="Visa kartlager">
                <LayerToggleCheckbox
                    label="Visa säljdistrikt"
                    checked={props.saleDistrictsVisible}
                    onChange={(e) => props.toggleSaleDistricts(e)}
                />
                <LayerToggleCheckbox
                    label="Visa gränser för A-region"
                    checked={props.regionVisible}
                    onChange={(e) => props.toggleOverlayArea(e, 'aregion', '#836cff', e.target.checked)}
                />
                <LayerToggleCheckbox
                    label="Visa kommungränser"
                    checked={props.municipalityVisible}
                    onChange={(e) => props.toggleOverlayArea(e, 'municipality', '#cb46f2', e.target.checked)}
                />
            </LayerToggleControl>
        </div>
    );
};

export default LayerTogglers;